const register = {
  loginCredentials: "Anmeldedaten", // translated
  companyInformation: "Firmeninformation", // translated
  contactDetails: "Kontaktdetails", // translated
  businessName: "Firmenname", // translated
  businessAddress: "Geschäftsadresse", // translated
  registrationCode: "Registrierungscode", // translated
  websiteUrl: "Webadresse", // translated
  mobilePhone: "Mobiltelefon", // translated
  regionStateProvince: "Region/Bundesland/Provinz", // translated
  legalTitle: "Legaler Titel", // translated
  city: "Stadt", // translated
  postalCode: "Postleitzahl", // translated
  registrationSuccess: "Registrierung erfolgreich.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "Bitte warten Sie einen Moment und Sie werden zur Startseite weitergeleitet.", // translated
};

export default register;
